export class CodeLinkageMappingModel {
    _id: string;
    deleted: number;
    project_id: string;
    created_by: string;
    created_time: Date;
    last_updated_by: string;
    last_updated_time: Date;
    approved: boolean;
    closed: boolean;
    merged: boolean;
    merged_by: string;
    merged_time: Date;
    reviewers: string[];
    projectmanagement_id: string;
    technicaldetails_id: string;
    artifactassociation_id: string;
    project_management_fields: string[];
    technical_details_fields: string[];
}